import React, {useState} from 'react';
import PropTypes from "prop-types";
import {
    XMarkIcon,
    ChartBarIcon,
    CreditCardIcon,
    ArrowsUpDownIcon,
    ReceiptPercentIcon,
    PercentBadgeIcon,
    UserGroupIcon,
    BanknotesIcon,
    MapIcon,
    TableCellsIcon, HomeIcon, RectangleGroupIcon, GlobeAltIcon, Squares2X2Icon
} from "@heroicons/react/24/outline";
import {
    Button,
    IconButton,
    Typography,
} from "@material-tailwind/react";

export function SideNav({role}) {
    const [openSidenav, setOpenSidenav] = useState(false);

    const routesByRole = {
        caja: [
            {
                path: "/dashboard",
                name: "Dashboard",
                icon: <ChartBarIcon className="h-5 w-5" />,
            },
            {
                path: "/payments",
                name: "Pago",
                icon: <CreditCardIcon className="h-5 w-5" />,
            },
        ],
        reports: [
            {
                path: "/dashboard",
                name: "Dashboard",
                icon: <ChartBarIcon className="h-5 w-5" />,
            },
            {
                path: "/reports",
                name: "Reportes",
                icon: <TableCellsIcon className="h-5 w-5" />,
            },
        ],
        admin: [
            {
                path: "/dashboard",
                name: "Dashboard",
                icon: <ChartBarIcon className="h-5 w-5" />,
            },
            {
                path: "/payments",
                name: "Pago",
                icon: <CreditCardIcon className="h-5 w-5" />,
            },
            {
                path: "/discounts",
                name: "Descuentos",
                icon: <PercentBadgeIcon className="h-5 w-5" />,
            },
            {
                path: "/invoices",
                name: "Recibos",
                icon: <ReceiptPercentIcon className="h-5 w-5" />,
            },
            {
                path: "/invoices/online_payments",
                name: "Pagos en linea",
                icon: <GlobeAltIcon className="h-5 w-5" />,
            },
            {
                path: "/lots",
                name: "Predios",
                icon: <HomeIcon className="h-5 w-5" />,
            },
            {
                path: "/movements",
                name: "Movimientos",
                icon: <ArrowsUpDownIcon className="h-5 w-5" />,
            },
            {
                path: "/reports",
                name: "Reportes",
                icon: <TableCellsIcon className="h-5 w-5" />,
            },
            {
                path: "/blocks",
                name: "Manzanas",
                icon: <Squares2X2Icon className="h-5 w-5" />,
            },
        ],
        treasury: [
            {
                path: "/dashboard",
                name: "Dashboard",
                icon: <ChartBarIcon className="h-5 w-5" />,
            },
            {
                path: "/reports",
                name: "Reportes",
                icon: <TableCellsIcon className="h-5 w-5" />,
            },
            {
                path: "/discounts",
                name: "Descuentos",
                icon: <PercentBadgeIcon className="h-5 w-5" />,
            },
        ],
        god: [
            {
                path: "/dashboard",
                name: "Dashboard",
                icon: <ChartBarIcon className="h-5 w-5" />,
            },
            {
                path: "/payments",
                name: "Pago",
                icon: <CreditCardIcon className="h-5 w-5" />,
            },
            {
                path: "/invoices",
                name: "Recibos",
                icon: <ReceiptPercentIcon className="h-5 w-5" />,
            },
            {
                path: "/invoices/online_payments",
                name: "Pagos en linea",
                icon: <GlobeAltIcon className="h-5 w-5" />,
            },
            {
                path: "/debts",
                name: "Adeudos",
                icon: <BanknotesIcon className="h-5 w-5" />,
            },
            {
                path: "/discounts",
                name: "Descuentos",
                icon: <PercentBadgeIcon className="h-5 w-5" />,
            },
            {
                path: "/maps",
                name: "Map",
                icon: <MapIcon className="h-5 w-5" />,
            },
            {
                path: "/lots",
                name: "Predios",
                icon: <HomeIcon className="h-5 w-5" />,
            },
            {
                path: "/movements",
                name: "Movimientos",
                icon: <ArrowsUpDownIcon className="h-5 w-5" />,
            },
            {
                path: "/reports",
                name: "Reportes",
                icon: <TableCellsIcon className="h-5 w-5" />,
            },
            {
                path: "/blocks",
                name: "Manzanas",
                icon: <Squares2X2Icon className="h-5 w-5" />,
            },
        ],
    };

    const defaultRoutes = [
        {
            path: "/dashboard",
            name: "Dashboard",
            icon: <ChartBarIcon className="h-5 w-5" />,
        },
    ];

    const routes = routesByRole[role] || defaultRoutes;

    const sidenavTypes = {
        dark: "bg-gradient-to-br from-gray-800 to-gray-900",
        white: "bg-white shadow-sm",
        transparent: "bg-transparent",
    };

    const toggleSidenav = () => {
        const sidenavElement = document.getElementById("sideNavbar");
        const isOpen = sidenavElement.classList.contains("translate-x-0");

        sidenavElement.classList.remove("translate-x-0", "-translate-x-80");
        sidenavElement.classList.add(isOpen ? "-translate-x-80" : "translate-x-0");
    };


    return (
        <aside
            id="sideNavbar"
            className={`${sidenavTypes.white} ${openSidenav ? "translate-x-0" : "-translate-x-80"} fixed inset-0 z-50 my-4 ml-4 h-[calc(100vh-32px)] w-72 rounded-xl transition-transform duration-300 xl:translate-x-0 border border-blue-gray-100 overflow-hidden`}
        >
            <div className={`relative`}>
                <a href="/" className="flex items-center py-4 px-6  bg-blue-gray-50">
                    <div className="bg-white justify-center items-center rounded-full h-full shadow-lg">
                        <img src="/favicon.png" alt="Recap Logo" className="h-10"/>
                    </div>
                    <Typography
                        variant="h4"
                        className="font-black uppercase px-3 font-sans"
                        style={{color: '#343434'}}
                    >
                        RECAP
                    </Typography>
                </a>
                <IconButton
                    variant="text"
                    color="white"
                    size="sm"
                    ripple={false}
                    className="absolute right-0 top-0 grid rounded-br-none rounded-tl-none xl:hidden"
                    style={{ marginTop: "10px", marginRight: "10px" }}
                    onClick={() => toggleSidenav()}
                >
                    <XMarkIcon strokeWidth={2.5} className="h-5 w-5 text-blue-900"/>
                </IconButton>
            </div>
            <div className="m-4">
                <ul key='1' className="mb-4 flex flex-col gap-1">
                    <li className="mx-3.5 mt-4 mb-2">
                        <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-black uppercase opacity-75"
                        >
                            Catastro
                        </Typography>
                    </li>
                    <li key='ux-basics'>
                        {routes.map(({ path, name, icon }) => {
                            const isActive = window.location.pathname === path;
                            return (
                                <a href={path} className="flex" key={path}>
                                    <Button
                                        variant={isActive ? "gradient" : "text"}
                                        color={isActive ? "blue" : "gray"}
                                        className="flex items-center gap-4 px-4 capitalize"
                                        fullWidth
                                    >
                                        {icon}
                                        <Typography color="inherit" className="font-medium capitalize">
                                            {name}
                                        </Typography>
                                    </Button>
                                </a>
                            );
                        })}
                    </li>
                </ul>
            </div>
        </aside>
    );
}

SideNav.defaultProps = {
    brandImg: "/img/logo-ct.png",
    brandName: "Material Tailwind React",
};

SideNav.propTypes = {
    brandImg: PropTypes.string,
    brandName: PropTypes.string,
    //routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

//SideNavUx.displayName = "/src/widgets/layout/sidenav.jsx";

export default SideNav;